import { Theme } from "@mui/material";
import { getContrastColor } from "theme/utils";

export default (theme: Theme) => ({
  group: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    gap: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      gap: "var(--rhythm)",
    },
  },

  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "calc(50% - var(--rhythm))",
    height: "calc(15 * var(--rhythm))",
    cursor: "pointer",
    overflow: "hidden",

    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },

  img: {
    flex: "1 1 auto",
    height: "calc(10.5 * var(--rhythm))",
    padding: "var(--rhythm)",
    objectFit: "contain",
    backgroundColor: "white",
  },

  control: {
    flex: "0 0 auto",
    height: "calc(2.5 * var(--rhythm))",
    margin: 0,
    backgroundColor: "var(--color-background)",
    ".MuiCheckbox-root": {
      "&::before": {
        content: "''",
        position: "absolute",
        display: "inline-block",
        width: "20px",
        height: "20px",
        borderRadius: "2px",
        backgroundColor: "white",
      },
    },
    ".MuiFormControlLabel-label": {
      fontWeight: 700,
    },
    selected: {
      backgroundColor: "var(--color-primary)",
      ".MuiCheckbox-root": {
        color: getContrastColor(),
        "&.Mui-checked": {
          color: getContrastColor(),
        },
      },
      ".MuiFormControlLabel-label": {
        fontWeight: 700,
        color: getContrastColor(),
      },
    },
  },
});
